export default __webpack_public_path__ + "static/media/CNo.77-1.486f00a4.jpg";